<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import { translation } from '$lib/locale/locale';
  import type { Tag } from '$lib/models/tag';
  import { AssetType } from '$lib/utils/asset';
  import bannerImage from '$lib/assets/search/banner-image.svg';

  let {} = translation();

  export let category: Tag | null;
  export let type: AssetType;
</script>

<aside>
  <img src={bannerImage} alt="" aria-hidden="true" loading="lazy" />
  <div class="content">
    {#if category?.bannerTitle && category?.bannerDescription}
      <h3>{category.bannerTitle}</h3>
      <p>{@html category.bannerDescription}</p>
    {:else if type == AssetType.Track}
      <h3>{m['search.banners.tracks.title']()}</h3>
      <p>{@html m['search.banners.tracks.description']()}</p>
    {:else if type == AssetType.SFX}
      <h3>{m['search.banners.sfx.title']()}</h3>
      <p>{@html m['search.banners.sfx.description']()}</p>
    {:else if type == AssetType.Intro}
      <h3>{m['search.banners.intros.title']()}</h3>
      <p>{@html m['search.banners.intros.description']()}</p>
    {/if}
  </div>
</aside>

<style lang="scss">
  @import '../../../variables.scss';

  aside {
    display: flex;
    flex-direction: row;
    background-color: $snow;
    align-items: center;
    padding: 40px;
    margin-top: 60px;
  }

  h3 {
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: $black-coral;
    padding-right: 24px;
  }

  img {
    width: 215px;
    height: 181px;
    margin-right: 36px;
  }

  @media (max-width: $svelte-mobile) {
    aside {
      flex-direction: column;
      font-size: 12px;
    }
    img {
      margin-right: auto;
      width: 134px;
      height: 113px;
    }
    h3 {
      font-size: 16px;
    }
    p {
      padding-right: 0;
      font-size: 14px;
      line-height: 22px;
    }
  }

  @media(max-width: 500px) {
    // Remove padding from the Bootstrap container
    aside {
      margin-left: -4%;
      margin-right: -4%;
      padding: 15px;
    }
  }
</style>
